module.exports = __webpack_public_path__ + "assets/img/ban8.75ba6159.png";